import axios from "axios";
import cognito from "@/js/cognito";

const baseURL = `${process.env.VUE_APP_API_BASE_URL}/api`;
const repository = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Content-Encoding": "gzip",
    "Service-Api-Key": process.env.VUE_APP_SERVICE_API_KEY
  }
});

repository.interceptors.request.use(async config => {
  return await cognito
    .isAuthenticated()
    .then(session => {
      if (Cognito.isCognitoUserSession(session)) {
        config.headers.Authorization = session.idToken.jwtToken;
      }
      return config;
    })
    .catch(() => {
      // ログイン情報がない場合、リクエストをキャンセル
      throw new axios.Cancel();
    });
});

// リトライ定義
//const LIMIT_RETRY_COUNT = 3;
repository.interceptors.response.use(
  response => {
    return Promise.resolve(response);
  },
  err => {
    return Promise.reject(err);
    // if (err.config.retryCount > LIMIT_RETRY_COUNT) {
    //   return Promise.reject(err);
    // }
    //
    // if (Number.isInteger(err.config.retryCount)) {
    //   err.config.retryCount += 1;
    // } else {
    //   err.config.retryCount = 1;
    // }
    // // json文字列になっているままだとエラーになる為
    // if (typeof err.config.data === "string") {
    //   err.config.data = JSON.parse(err.config.data);
    // }
    //
    // return axios.request(err.config);
  }
);

export default repository;
import Cognito from "@/js/cognito/cognito";
// -------------------------------------------------------
// FIXME スタブ領域 ビルド時は削除 ↓全部
import MockAdapter from "axios-mock-adapter";
import screenAuthorityMock from "./mocks/screenAuthorityMock";
import disasterInfoMock from "./mocks/disasterInfoMock";
import allAreaMock from "./mocks/allAreaMock";
import lodineDistributionMock from "./mocks/lodineDistributionMock";
import facilityEvaInfoMock from "./mocks/facilityEvaInfoMock";
import disasterDeliveryMock from "./mocks/disasterDeliveryMock";
import disasterDeliveryDetailMock from "./mocks/disasterDeliveryDetailMock";
import fixedPhraseMock from "./mocks/fixedPhraseMock";
import fileS3UploadMock from "./mocks/fileS3UploadMock";
import fileS3UrlMock from "./mocks/fileS3UrlMock";
import authorityCheckMock from "./mocks/authorityCheckMock";
// 以下はモック用の仮のRepositoryと併用中、修正予定
import disasterMock from "./mocks/disasterMock";
import facilityMock from "./mocks/facilityMock";
import vulFacilityMock from "./mocks/vulFacilityMock";
import vulFacilityStatusMock from "./mocks/vulFacilityStatusMock";
import organizeMstMock from "./mocks/organizeMstMock";
import opeAuthMstMock from "./mocks/opeAuthMstMock";
import opeauthgpMstMock from "./mocks/opeauthgpMstMock";
import disasterStaffMstMock from "./mocks/disasterStaffMstMock";
import disasterPreventionFaMock from "./mocks/disasterPreventionFaMock";
import disasterStaffDeliveryMock from "./mocks/disasterStaffDeliveryMock";
import evaFacilityStatusMock from "./mocks/evaFacilityStatusMock";
import chronologyMock from "./mocks/chronologyMock";
import oilMock from "./mocks/oilMock";
import busQrCodeMock from "./mocks/busQrCodeMock";
import vulFacilityEvagrpMock from "./mocks/vulFacilityEvagrpMock";
import considerationPersonUploadMock from "./mocks/considerationPersonUploadMock";
import considerationPersonInfoMock from "./mocks/considerationPersonInfoMock";
import studentInfoMock from "./mocks/studentInfoMock";
import studentUploadMock from "./mocks/studentUploadMock";
import tmpQrcodeUploadMock from "./mocks/tmpQrcodeUploadMock";
import tmpQrcodeGroupMock from "./mocks/tmpQrcodeGroupMock";
import tmpQrresidentsMock from "./mocks/tmpQrresidentsMock";
import carMock from "./mocks/carMock";
import carOperatorMock from "./mocks/carOperatorMock";
import equipmentMock from "./mocks/equipmentMock";
import equipmentMountManMock from "./mocks/equipmentMountManMock";
import carMountEquipmentMock from "./mocks/carMountEquipmentMock";
import equipmentDeployMock from "./mocks/equipmentDeployMock";
import inspectionResultMock from "./mocks/inspectionResultMock";
import dpndAuthInfoMock from "./mocks/dpndAuthInfoMock";
if (process.env.VUE_APP_MOCK === "valid") {
  // 以下の行が実行されるとaxiosがmockモードになる
  const mock = new MockAdapter(repository, { delayResponse: 1000 });
  // 階層の深いパスから定義
  screenAuthorityMock(mock);
  disasterInfoMock(mock);
  allAreaMock(mock);
  lodineDistributionMock(mock);
  facilityEvaInfoMock(mock);
  disasterDeliveryMock(mock);
  disasterDeliveryDetailMock(mock);
  fixedPhraseMock(mock);
  fileS3UploadMock(mock);
  fileS3UrlMock(mock);
  facilityMock(mock);
  vulFacilityMock(mock);
  vulFacilityStatusMock(mock);
  organizeMstMock(mock);
  opeAuthMstMock(mock);
  opeauthgpMstMock(mock);
  disasterStaffMstMock(mock);
  disasterPreventionFaMock(mock);
  disasterStaffDeliveryMock(mock);
  evaFacilityStatusMock(mock);
  authorityCheckMock(mock);
  disasterMock(mock);
  chronologyMock(mock);
  oilMock(mock);
  busQrCodeMock(mock);
  vulFacilityEvagrpMock(mock);
  considerationPersonUploadMock(mock);
  considerationPersonInfoMock(mock);
  studentInfoMock(mock);
  studentUploadMock(mock);
  tmpQrcodeUploadMock(mock);
  tmpQrcodeGroupMock(mock);
  tmpQrresidentsMock(mock);
  carMock(mock);
  carOperatorMock(mock);
  equipmentMock(mock);
  equipmentMountManMock(mock);
  carMountEquipmentMock(mock);
  equipmentDeployMock(mock);
  inspectionResultMock(mock);
  dpndAuthInfoMock(mock);
}
// -------------------------------------------------------
